const FOLLOW_ON_STUDY_TYPE = 'FOLLOW-ON STUDY';

const STUDY_TYPES = {
  MCT: 'MCT',
  MCT_PEEK: 'MCT PEEK',
  CARDIAC_EVENT: 'CARDIAC EVENT',
  HOLTER: 'HOLTER',
  EXTENDED_HOLTER: 'EXTENDED HOLTER',
  FOLLOW_ON_STUDY: FOLLOW_ON_STUDY_TYPE,
};

const STUDY_STATUS = {
  DRAFT: 'Draft',
  STARTING: 'Starting',
  ABORTED: 'Aborted',
  STARTED: 'Started',
  PAUSED: 'Paused',
  RESUMED: 'Resumed',
  COMPLETED: 'Completed',
  UPLOADING: 'Uploading',
  UPLOADED: 'Uploaded',
  ERASING: 'Erasing',
  ERASED: 'Erased',
  STOPPING: 'Stopping',
  ONGOING: 'Ongoing',
  DONE: 'Done',
};

const STUDY_TYPE_OPTIONS = [
  {
    label: 'MCT - 93228-93229',
    value: 'MCT',
  },
  {
    label: 'MCT PEEK - 93228-93229',
    value: 'MCT PEEK',
  },
  {
    label: 'CARDIAC EVENT - 93268-93272',
    value: 'CARDIAC EVENT',
  },
  {
    label: 'HOLTER - 93224-93227',
    value: 'HOLTER',
  },
  {
    label: 'EXTENDED HOLTER - 93241-93247',
    value: 'EXTENDED HOLTER',
  },
  {
    label: FOLLOW_ON_STUDY_TYPE,
    value: FOLLOW_ON_STUDY_TYPE,
  },
];

const VIRTU_OX_STUDY_TYPE_OPTIONS = [
  {
    label: 'HOLTER - 93224-93227',
    value: 'HOLTER',
  },
  {
    label: 'EXTENDED HOLTER - 93241-93247',
    value: 'EXTENDED HOLTER',
  },
];

const TIME_UNIT_OPTIONS = [
  {
    value: 'day',
    label: 'day(s)',
    title: 'day(s)',
  },
  {
    value: 'hour',
    label: 'hour(s)',
    title: 'hour(s)',
  },
];

const PRIMARY_STUDY_TYPE_LIST = [
  {
    label: STUDY_TYPES.HOLTER,
    value: STUDY_TYPES.HOLTER,
  },
  {
    label: STUDY_TYPES.EXTENDED_HOLTER,
    value: STUDY_TYPES.EXTENDED_HOLTER,
  },
];

const RING_ID_DEVICE_SCHEMA = '04018816';

export {
  FOLLOW_ON_STUDY_TYPE,
  STUDY_TYPES,
  STUDY_STATUS,
  STUDY_TYPE_OPTIONS,
  VIRTU_OX_STUDY_TYPE_OPTIONS,
  PRIMARY_STUDY_TYPE_LIST,
  RING_ID_DEVICE_SCHEMA,
  TIME_UNIT_OPTIONS,
};
